module.exports = __webpack_public_path__ + "static/img/game3.497d0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game3.png
// module id = bV9u
// module chunks = 1